"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styled = require("../buttons/custom-button/styled");
var _constant = require("../../constant");
var _styled2 = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var FiltersSideBar = function FiltersSideBar(_ref) {
  var placeholder = _ref.placeholder,
    children = _ref.children,
    close = _ref.close,
    setClose = _ref.setClose;
  var containerRef = (0, _react.useRef)();
  var initialWidth = 400;
  var _useState = (0, _react.useState)(initialWidth),
    _useState2 = _slicedToArray(_useState, 2),
    position = _useState2[0],
    setPosition = _useState2[1];
  (0, _react.useEffect)(function () {
    if (close && setClose) {
      setPosition(initialWidth);
      setClose(false);
    }
  }, [close]);
  var toggleMenu = function toggleMenu() {
    if (position > 0) {
      setPosition(0);
    } else {
      setPosition(initialWidth);
    }
  };
  var handleClickOutside = function handleClickOutside(event) {
    if (!containerRef || containerRef && containerRef.current && !containerRef.current.contains(event.target)) {
      setPosition(initialWidth);
    }
  };
  (0, _react.useEffect)(function () {
    document.addEventListener('click', handleClickOutside, true);
    return function () {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_styled2.Container, null, /*#__PURE__*/_react.default.createElement(_styled2.Wrapper, null, /*#__PURE__*/_react.default.createElement(_styled.CustomButton, {
    color: _constant.colors.VIOLET,
    onClick: toggleMenu,
    $bsStyle: "min-width: 100px; width: 170px;"
  }, placeholder)), /*#__PURE__*/_react.default.createElement(_styled2.SideBarRight, {
    ref: containerRef,
    transform: position,
    width: "".concat(initialWidth, "px")
  }, /*#__PURE__*/_react.default.createElement(_styled2.CloseButton, {
    id: "toggle-icon",
    onClick: toggleMenu,
    close: position !== initialWidth,
    isOpen: position === 0
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "top ".concat(position === 0 ? 'open' : '')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "mid ".concat(position === 0 ? 'open' : '')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "bot ".concat(position === 0 ? 'open' : '')
  })), /*#__PURE__*/_react.default.createElement(_styled2.Menu, null, children)));
};
FiltersSideBar.propTypes = {
  placeholder: _propTypes.default.string,
  setClose: _propTypes.default.func,
  close: _propTypes.default.bool
};
FiltersSideBar.defaultProps = {
  placeholder: 'Select',
  setClose: undefined,
  close: false
};
var _default = FiltersSideBar;
exports.default = _default;